import React from "react";
import {flexRender} from "@tanstack/react-table";
import {EditButton} from "./EditButton";
import {DeleteButton} from "./DeleteButton";

export const TableButtonGroup = ({
                                     row,
                                     children,
                                     setGlobalFilter,
                                     deleteEndpoint,
                                     showEditButton,
                                     showDeleteButton
                                 }) => {


    return <div>
        {showEditButton && <EditButton row={row}/>}
        {children}
        {showDeleteButton && <DeleteButton row={row} deleteEndpoint={deleteEndpoint}
                                           updateTable={() => setGlobalFilter(new Date())}/>}
    </div>

}

export const TableButtonOptions = ({
                                       children, deleteEndpoint, showEditButton = true, showDeleteButton = true,
                                       width = 150,
                                       maxWidth = 150,
                                       minWidth = 150
                                   }) => {
    return {
        header: ' ',
        accessorKey: '_options',
        enableSorting: false,
        export: false,
        collapse: true,
        maxWidth: maxWidth,
        minWidth: 150,
        width: width,
        enableColumnFilter: false,
        cell: ({row, table, cell}) => {
            return (
                <div className="text-center p-1">
                    <TableButtonGroup row={row} setGlobalFilter={table.setGlobalFilter} deleteEndpoint={deleteEndpoint}
                                      showEditButton={showEditButton} showDeleteButton={showDeleteButton}>
                        {children && flexRender(
                            children,
                            cell.getContext()
                        )}
                    </TableButtonGroup>
                </div>
            )
        }
    }
}
